<template>
  <div class="champion">
    <h2 class="title">{{score_list.name}}</h2>
    <div class="select_box">
      <div class="sel_list" v-for="(item,index) in tab_list">
        <span>{{item.name}}:</span><select class="select_title comm_sel" @change="changeProduct($event,index)">
        <option v-for="(item2,index) in sel_list[index]" :key="index" :value="item2.name">{{item2.name}}</option>
      </select>
      </div>
    </div>
    <template v-if="!score_list.result">
    <div class="sel_list addmargin">
      <span>获取方式：</span>
      <select class="select_title comm_sel" @change="changeGetOption()" v-model="options">
        <option value="现场领取">现场领取</option>
        <option value="邮寄">邮寄</option>
      </select>
    </div>
    <div class="address_box" v-if="is_option">
      <div class="input_box">
        <span>收件人：</span>
        <div class="ins">
          <input class="comm_input" placeholder="收件人" type="text" v-model="input_val1"/>
        </div>
      </div>
      <div class="input_box">
        <span>联系方式：</span>
        <div class="ins">
          <input class="comm_input" placeholder="手机号" type="text" v-model="input_val2"/>
        </div>
      </div>
      <div class="input_box">
        <span>邮寄地址：</span>
        <div class="ins">
          <input class="comm_input" placeholder="邮寄地址" type="text" v-model="input_val3"/>
        </div>
      </div>
    </div>
    <p class="mess_bottom" v-if="!is_option">{{score_list.self_take}}</p>
    <button class="sub_btn" :disabled="score_list.guess_count>=score_list.limite_guess_count || score_list.is_over_time==1" @click="subbtn">{{score_list.is_over_time==1? '竞猜已结束' : '提交'}}</button>
    </template>
    <template v-if="score_list.result">
      <button class="sub_btn" @click="con" disabled="true" >您的竞猜结果是：{{score_list.result}}</button>
    </template>
  </div>
</template>

<script>
    export default {
        name: "Champion",
        props: {
            score_list: {},
            tab_list: {},
            sel_list: {}
        },
        data() {
            return {
                select_post: [],
                ProductActive: [],
                is_option: true,
                input_val1:'',
                input_val2:'',
                input_val3:'',
                options:'邮寄'
            }
        },
        computed: {
            address(){
                return '收件人：'+this.input_val1+',联系方式'+this.input_val2+',邮寄地址：'+this.input_val3
            }
        },
        watch: {
            sel_list:
                function(newVlaue,oldName){
                    return this.ProductActive = [newVlaue[0][0].name, newVlaue[0][0].name, newVlaue[0][0].name]
                },
                immediate:true,
                deep: true,


        },
        methods: {
            con(){
              console.log(this.ProductActive)
            },
            subbtn() {
                console.log(this.ProductActive)
                if (this.options == '邮寄'){
                    if (this.input_val1 !='' && this.input_val2 !='' && this.input_val3!='' ) {
                        this.$axios({
                            url: 'https://api.hainanfa.org.cn/guess/Submite',
                            method: 'post',
                            params: {
                                item_id: this.score_list.id,
                                result: encodeURI(this.ProductActive.toString()),
                                match_id: this.score_list.match_id,
                                user_id: localStorage.getItem("id"),
                                email_address:encodeURI(this.address)
                            },
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                            }
                        }).then(res => {
                            if (res.data.status == 0) {
                                alert('提交成功')
                                this.$router.push({path: 'list'})
                            }
                            if (res.data.status == 400002) {
                                alert('您已经竞猜过了，看看别的吧')
                                this.$router.push({path: 'list'})
                            }

                        }).catch(err => {
                            console.log(err)
                        })
                    }else {
                        alert('请填写好您的信息')
                    }
                } else{
                    this.$axios({
                        url: 'https://api.hainanfa.org.cn/guess/Submite',
                        method: 'post',
                        params: {
                            item_id: this.score_list.id,
                            result: encodeURI(this.ProductActive.toString()),
                            match_id: this.score_list.match_id,
                            user_id: localStorage.getItem("id"),
                            email_address:encodeURI('用户现场自取')
                        },
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                        }
                    }).then(res => {
                        if (res.data.status == 0) {
                            alert('提交成功')
                            this.$router.push({path: 'list'})
                        }
                        if (res.data.status == 400002) {
                            alert('您已经竞猜过了，看看别的吧')
                            this.$router.push({path: 'list'})
                        }

                    }).catch(err => {
                        console.log(err)
                    })
                }
                // console.log(this.sel_list)

            },
            changeProduct(event, index) {
                this.ProductActive[index] = event.target.value; //获取option对应的value值
            },
            changeGetOption() {
                this.is_option = !this.is_option;
                console.log(this.score_list)
            }
        }
    }
</script>

<style scoped>
  .title {
    font-size: 22px;
    font-weight: bold;
    color: #000000;
    line-height: 1.5;
  }

  .select_box {
    margin: 20px 0;
  }




</style>
